import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CreatePrompt } from './pages/CreatePrompt';
import { ViewPrompt } from './pages/ViewPrompt';
import { Dashboard } from './pages/Dashboard';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-br from-pink-400 via-rose-400 to-red-400" data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/create" element={<CreatePrompt data-id="element-6" />} data-id="element-5" />
          <Route path="/prompt/:id" element={<ViewPrompt data-id="element-8" />} data-id="element-7" />
          <Route path="/dashboard" element={<Dashboard data-id="element-10" />} data-id="element-9" />
        </Routes>
      </BrowserRouter>
    </div>;
}